"use client";

import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import ChangePasswordDialog from "@/features/auth/components/change-password-dialog";
import { federatedLogout } from "@/lib/auth-client";
import { UserRound } from "lucide-react";
import { useSession } from "next-auth/react";
import { useTranslations } from "next-intl";
import React, { useState } from "react";

export default function UserPopover() {
  const { data: session, status } = useSession();
  const t = useTranslations();
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

  const handleLogout = async () => {
    await federatedLogout();
  };

  const displayName = session?.user?.name ?? "";

  return (
    <>
      <Popover>
        <PopoverTrigger asChild>
          <button className="flex size-10 items-center justify-center rounded-full bg-card/20 hover:shadow">
            <UserRound />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-60 -translate-x-3">
          <div className="flex flex-col gap-1">
            <span className="flex items-center gap-1 px-4 py-2 font-medium">
              <span className="shrink-0">Hi,</span>
              <span className="min-w-0 truncate capitalize" title={displayName}>
                {displayName}
              </span>
            </span>
            <Separator />
            <Button
              variant="ghost"
              className="justify-start"
              onClick={() => setIsChangePasswordOpen(true)}
              disabled={status !== "authenticated"}
            >
              Đổi mật khẩu
            </Button>
            <Button
              variant="ghost"
              className="justify-start"
              onClick={handleLogout}
              disabled={status !== "authenticated"}
            >
              {t("action.logout")}
            </Button>
          </div>
        </PopoverContent>
      </Popover>
      <ChangePasswordDialog
        isOpen={isChangePasswordOpen}
        setIsOpen={setIsChangePasswordOpen}
      />
    </>
  );
}
